<style lang="scss" scoped="">
// .gy-html {
//   margin-top: 10px;
//   text-align: center !important;
// }

// .gy-html /deep/ table {
//   color: #303133 !important;
// }

// .gy-html /deep/ table tbody tr:first-child {
//   background-color: #909399 !important;
//   color: #FFFFFF IM !important;
// }
.container::-webkit-scrollbar {
  display: none;
}

.technologyTable {
  margin-top: 10px;
  font-size: 12px;
  text-align: center;
  border: none !important;
  //#606672
}

.technologyTable /deep/ table {
  border-collapse: collapse;
}

.technologyTable /deep/ table tbody tr:first-child {
  height: 42px;
  font-size: 12px;
}

.technologyTable /deep/ table tbody tr:not(:first-child) {
  height: 26px;
  font-size: 12px;
}
</style>

<template>
  <div class="container" style="overflow: auto;position: relative">
    <div class="technologyTable" v-html="gy"></div>
    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(store.state.eqPoints[equipment.id][tapCode] && store.state.eqPoints[equipment.id][tapCode].alias)" :visible.sync="isShowDetailDialog" :width="'720px'" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <technology_detail :equipment="equipment" :tapCode="tapCode"></technology_detail>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import technology_detail from "@@/pages/web/monitor/workshop_mes/equipment/statistics_tabs/technology_detail";
const execMathExpress = require("exec-mathexpress");
export default {
  name: "web_monitor_equipment_statistics_tabs_technology",
  components: {
    technology_detail: technology_detail,
  },
  props: {
    equipment: {
      type: Object,
      default: function() {
        return {};
      },
    },
    tabsData: {
      type: Object,
      default: function() {
        return {};
      },
    },
    tapCode: null,
  },
  data() {
    return {
      isShowDetailDialog: false,
      equipmentPoints:{},
    };
  },
  created() {
    this.equipmentPoints = this.store.state.eqPoints[this.equipment.id];
  },
  watch: {
    isShowDetailDialog: {
      handler(newValue, oldValue) {
        if (newValue == false) {
          setTimeout(() => {
            this.clearCodeTap();
            this.bindCodeTap();
          }, 100);
        }
        console.log("改变");
      },
      deep: true,
      immediate: true,
    },

    tabsData: {
      handler(newValue, oldValue) {
        console.log("改变");
        setTimeout(() => {
          this.clearCodeTap();
          this.bindCodeTap();
        }, 100);
      },
      deep: true,
      immediate: true,
    },
  },

  computed: {
    gy() {
      let str = this.tabsData.tab.gy;
      str = this.base64.decode(str);
      let reg1 = /\[[^\]]*\]/g;
      str.match(reg1) &&
        str.match(reg1).map((code) => {
          let c = code.replace("[", "");
          c = c.replace("]", "");
          str = str.replace(code, this.$t(c));
        });
      let reg2 = /\{[^\}]*\}/g;
      str.match(reg2) &&
        str.match(reg2).map((code) => {
          let c = code.replace("{", "");
          c = c.replace("}", "");

          if (!this.equipmentPoints[c]) {
            console.log("gongyimobanqueshaodian" + ":" + c);
            return;
          }

          let value = this.tabsData.eqPoints[c] ? this.tabsData.eqPoints[c] : "";

          if (this.equipmentPoints[c].dictTypeCode != null) {
            str = str.replace(code, this.$t(this.store.state.dictJsonAll[this.equipmentPoints[c].dictTypeCode][parseInt(value)]));
          } else {
            str = str.replace(code, value);
          }
        });
      return str;
    },
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on("RESIZE", () => {
      this.resize();
    });
    this.bindCodeTap();
  },

  destroyed() {
    this.clearCodeTap();
  },
  methods: {
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {}, 500);
    },
    clearCodeTap() {
      let tables = document.getElementsByClassName("technologyTable")[0].getElementsByTagName("table");
      for (var i = 0; i < tables.length; i++) {
        let trs = tables[i].getElementsByTagName("tr");

        for (var j = 0; j < trs.length; j++) {
          let tds = trs[j].getElementsByTagName("td");

          for (var k = 0; k < tds.length; k++) {
            if (tds[k].getAttribute("code")) {
              tds[k].removeEventListener("click", this.codeTap, true);
            }
          }
        }
      }
    },
    bindCodeTap() {
      let tables = document.getElementsByClassName("technologyTable")[0].getElementsByTagName("table");
      for (var i = 0; i < tables.length; i++) {
        let trs = tables[i].getElementsByTagName("tr");

        for (var j = 0; j < trs.length; j++) {
          let tds = trs[j].getElementsByTagName("td");

          for (var k = 0; k < tds.length; k++) {
            if (tds[k].getAttribute("code")) {
              tds[k].removeEventListener("click", this.codeTap, true);
              tds[k].addEventListener("click", this.codeTap, true);
            }
          }
        }
      }
    },
    codeTap(e) {
      if (!e.target.attributes.code.value) {
        return;
      }
      this.tapCode = e.target.attributes.code.value;
      let points = this.store.state.eqPoints[this.equipment.id];
      if(points[this.tapCode] == null || points[this.tapCode].dataType == 1){
        return;
      }
      this.isShowDetailDialog = true;
    },
  },
};
</script>
